import { CommonModule, NgIf } from '@angular/common'
import { AfterViewInit, Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { BlockUnblockComponent } from '../../template/block-unblock/block-unblock.component'
import { DeleteComponent } from '../../template/delete/delete.component'
import { PaginationComponent } from '../../template/pagination/pagination.component'
import { Store } from '@ngrx/store'
import { NgbModal, NgbModalRef, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { filter, map, Observable, of, Subject, take, takeUntil } from 'rxjs'
import { AppliedLeave } from '../../../../store/applied-leave/applied-leave.state'
import {
  selectAppliedLeaves,
  selectTotalCount
} from '../../../../store/applied-leave/applied-leave.reducer'
// import { selectTotalCount } from '../../../store/applied-leave/applied-leave.selectors'
import {
  createAppliedLeave,
  createAppliedLeaveFailure,
  createAppliedLeaveSuccess,
  loadAppliedLeaves,
  updateAppliedLeave,
  updateAppliedLeaveFailure,
  updateAppliedLeaveSuccess
} from '../../../../store/applied-leave/applied-leave.actions'
import dayjs from 'dayjs'
import {
  NgxDaterangepickerBootstrapDirective,
  NgxDaterangepickerBootstrapComponent
} from 'ngx-daterangepicker-bootstrap'
import { AuthState, User } from '../../../../store/auth/auth.state'
import { selectUser } from '../../../../store/auth/auth.selectors'
import { HasPermissionDirective } from '../../../../directives/has-permission.directive'
import { selectAllBusinesses } from '../../../../store/business/business.selectors'
import { Business } from '../../../../store/business/business.state'
import { loadBusinesses } from '../../../../store/business/business.actions'
import { selectAllUsers } from '../../../../store/user/user.selectors'
import { loadEmployees, resetEmployeeState } from '../../../../store/user/user.actions'
import { Actions, ofType } from '@ngrx/effects'
import { LeaveType } from '../applied-leaves/applied-leaves.component'
import { eps } from '../../../../services/url.service'
import { NgSelectModule } from '@ng-select/ng-select'
import { LeavePolicyService } from '../../../../services/leave-policy.service'
import { LeavePolicy } from '../../../../store/leave-policy/leave-policy.state'
import { environment } from '../../../../../environments/environment'
import { UtilsService } from '../../../../services/utils.service'
import { SharedModule } from '../../../../shared/shared.module'

// export enum LeaveType {
//   LEAVEWITHOUTPAY = 'Leave Without Pay',
//   CASUAL = 'Casual Leave',
//   SICK = 'Sick Leave'
// }

export enum OffType {
  FULLDAY = 'Full Day',
  HALFDAY = 'Half Day',
  FIRSTHALF = 'First Half',
  SECONDHALF = 'Second Half'
}

export enum StatusType {
  APPROVED = 'Approved',
  CANCELLED = 'Cancelled',
  REJECTED = 'Rejected',
  PENDING = 'Pending',
  CANCELREQUESTED = 'Cancel Requested'
}

interface DateRange {
  startDate: dayjs.Dayjs
  endDate: dayjs.Dayjs
}

declare var bootstrap: any // Add this if you haven't already
declare var $: any // Declare jQuery

@Component({
  selector: 'app-leaves-request',
  imports: [
    ReactiveFormsModule,
    NgIf,
    CommonModule,
    RouterModule,
    CapitalizePipe,
    // BlockUnblockComponent,
    FormsModule,
    // DeleteComponent,
    PaginationComponent,
    NgbTooltipModule,
    NgxDaterangepickerBootstrapDirective,
    // NgxDaterangepickerBootstrapComponent,
    HasPermissionDirective,
    NgSelectModule,
    SharedModule
    // BrowserAnimationsModule
  ],
  templateUrl: './leaves-request.component.html',
  styleUrl: './leaves-request.component.scss'
})
export class LeavesRequestComponent implements OnInit, AfterViewInit {
  private store = inject(Store) // Inject store using `inject()`
  @ViewChild('addBusinessModals') addBusinessModals!: TemplateRef<any>
  @ViewChild('cancelAppliedLeaveModal') cancelAppliedLeaveModal!: TemplateRef<any>

  private modalRef!: NgbModalRef
  private router = inject(Router)
  currentPage = 1
  pageLimit = 10
  loading$: Observable<boolean> = this.store.select(state => state.appliedLeaves.loading)
  error$: Observable<string | null> = this.store.select(state => state.appliedLeaves.error)
  pageLastRecord = 0
  form!: FormGroup
  appliedLeaves$: Observable<AppliedLeave[]> = this.store.select(selectAppliedLeaves)
  totalCount$!: Observable<number>
  totalCount = 0
  search = ''
  leaveTypeEnum = LeaveType // Make the enum accessible in the template
  offTypeEnum = OffType
  statusEnum = StatusType
  dateRange: DateRange | null = null
  dateRangeModal = ''
  leaveType = ''
  leaveTypes = Object.values(LeaveType) // Get an array of the enum values for iteration
  minDate: dayjs.Dayjs | null = null

  status = ''
  dateRangeforHalfDay: { date: string; halfDayOption: string; selectionType: string }[] = [] // Store date and half-day selection
  toDateInvalid = false
  minToDate: string | null = null // Minimum value for toDate
  fromDateSelected = false
  // Get the current date
  private currentDate = new Date()
  private route = inject(ActivatedRoute)

  // Set the start date to January 1st of the current year
  private startOfYear = new Date(this.currentDate.getFullYear(), 0, 1)

  // Set the end date to December 31st of the current year
  private endOfYear = new Date(this.currentDate.getFullYear(), 11, 31)

  // Format dates to 'YYYY-MM-DD' format
  fromDateFilter = this.startOfYear.toISOString().split('T')[0] // 'YYYY-MM-DD'
  toDateFilter = this.endOfYear.toISOString().split('T')[0] // 'YYYY-MM-DD'
  leavesResponse: any
  disabledDates: any[] = []
  isHalfDay = true
  blockUnblockStatus = ''
  EditHoliday: any
  employeeLeaveDetail: any
  public defaultImg = '../../../../assets/img/user.jpg'
  businesses$: Observable<Business[]> = this.store.select(selectAllBusinesses)
  employees$!: Observable<User[]>
  selectedBusinessId = ''
  private destroyed$ = new Subject<void>()
  user: AuthState['user'] | null = null
  private leavePolicyService = inject(LeavePolicyService)
  leavePolicies$: Observable<LeavePolicy[]> = of([])

  leavePolicies: any[] = []
  public selectedLeave: any = ''
  parsedDateRange: { date: string; halfDayOption: string; selectionType: string }[] = []
  showDatePicker = false
  apiEndpoint = environment.apiBaseUrl
  private employeeJoiningDate = '' // add at class level if needed
  isDisabled = true
  leaveId: string | null = null
  fromNotification = false

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private actions$: Actions,
    private utilsService: UtilsService
  ) {
    this.appliedLeaves$ = this.store.select(selectAppliedLeaves)
    this.totalCount$ = this.store.select(selectTotalCount).pipe(
      map(totalCount => totalCount || 0) // Default to 0 if totalCount is null
    )
    this.store.dispatch(loadBusinesses({ params: 'disabled=false' }))
    this.employees$ = this.store.select(selectAllUsers)

    // Subscribe to totalCount$ safely
    // this.totalCount$.subscribe(count => {
    //   this.totalCount = count // Define this.totalCount in your class
    // })
  }

  ngOnInit() {
    this.status = 'Pending'

    this.route.queryParams.subscribe(params => {
      this.leaveId = params['id'] || null
      // eslint-disable-next-line no-console
      // console.log('Leave ID from URL:', this.leaveId)
      this.fromNotification = params['fromNotification'] === 'true'
      this.loadAppliedLeaves()
    })

    // this.loadAppliedLeaves()

    this.totalCount$.subscribe(count => {
      this.totalCount = count
      this.updatePageLastRecord()
    })

    this.form = this.fb.group({
      userId: [''], // Example validators
      fromDate: ['', [Validators.required]], // Example validators
      toDate: ['', [Validators.required]],
      reason: [''], // Example validators
      // leaveType: [''],
      leavePolicyId: ['', Validators.required],
      offType: [''],
      status: ['Pending'],
      statusReason: [''],
      halfDayOption: [''],
      daterange: [''],
      businessId: [''],
      leavePolicy: ['']
    })

    this.actions$
      .pipe(
        ofType(createAppliedLeaveSuccess, createAppliedLeaveFailure),
        takeUntil(this.destroyed$) // don't forget to clean up
      )
      .subscribe(() => {
        this.form.reset({
          status: 'Pending', // 👈 preserve the default value
          statusReason: '',
          businessId: '',
          userId: '',
          leavePolicyId: ''
        })
        this.EditHoliday = ''
        this.dateRangeforHalfDay = []

        // this.status = 'Pending'
        // this.leaveId = null
        // this.fromNotification = false
        // this.dateRange = null
        // this.leaveType = ''
        // this.currentPage = 1
        this.modalService.dismissAll() // or modalRef.close() if you're using one
        this.loadAppliedLeaves()
      })

    this.actions$
      .pipe(
        ofType(updateAppliedLeaveSuccess, updateAppliedLeaveFailure),
        takeUntil(this.destroyed$) // don't forget to clean up
      )
      .subscribe(() => {
        this.form.reset({
          status: 'Pending', // 👈 preserve the default value
          statusReason: '',
          businessId: ''
        })
        this.dateRangeforHalfDay = []
        this.modalService.dismissAll() // or modalRef.close() if you're using one
        this.loadAppliedLeaves()
        this.EditHoliday = ''
      })

    // Subscribe and store leavePolicies
    this.leavePolicies$.subscribe(policies => {
      this.leavePolicies = policies
    })

    // Now listen for leavePolicyId changes
    this.form.get('leavePolicy')?.valueChanges.subscribe((selected: any) => {
      // console.log('leavePolicy changed:', selected)

      this.form.patchValue({
        leaveType: selected?.leaveType || '',
        leavePolicyId: selected?.id || ''
      })
    })
    // this.route.queryParams.subscribe(params => {
    //   if (params['openModal']) {
    //     setTimeout(() => {
    //       this.openBusinessModal(this.addBusinessModals)
    //     }, 300)
    //   }
    // })
    this.route.queryParams.subscribe(params => {
      if (!params['openModal']) return

      const businessId = params['businessId']
      const userId = params['userId']

      this.form.patchValue({ businessId })
      this.selectedBusinessId = businessId

      this.onBusinessChange(businessId)

      this.employees$
        .pipe(
          filter(employees => employees.length > 0),
          take(1)
        )
        .subscribe(() => {
          this.form.patchValue({ userId })
          this.onEmployeeSelect()
          // this.form.get('daterange')?.enable()
          // setTimeout(() => {
          //   this.openBusinessModal(this.addBusinessModals)
          // }, 300)
          setTimeout(() => {
            this.openBusinessModal(this.addBusinessModals)
            this.form.get('daterange')?.enable()
            this.initDatePicker()
          }, 300)
        })
    })
    this.route.queryParams.subscribe(params => {
      if (params['fromNotification']) {
        this.status = ''
        this.dateRange = null
        this.currentPage = 1

        this.loadAppliedLeaves()
      }
    })
    this.store
      .select(selectUser)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(user => {
        this.user = user
      })
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    //   this.showDatePicker = true
    // })
    this.initDatePicker()
  }

  onDateRangeChange(range: any) {
    if (!range) return
    this.leaveId = null
    this.fromNotification = false
    this.dateRange = range
    this.loadAppliedLeaves()
  }
  // this code is add by shivam
  calculateLeaveDays(startDate: string, endDate: string): number {
    if (!startDate || !endDate) return 0

    const start = new Date(startDate)
    const end = new Date(endDate)

    const diffTime = end.getTime() - start.getTime()

    return Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1
  }

  // -------------------END-----------------
  loadAppliedLeaves() {
    const params: any = {}

    // if (this.leaveId) {
    //   params.id = this.leaveId
    //   this.status = ''
    // }

    if (this.leaveId && this.fromNotification) {
      params.id = this.leaveId
    }

    if (this.leaveType) {
      params.leaveType = this.leaveType
    }
    if (this.status) {
      params.status = this.status
    }
    if (this.dateRange?.startDate && this.dateRange?.endDate) {
      params.fromDate = this.dateRange.startDate.format('YYYY-MM-DD')
      params.toDate = this.dateRange.endDate.format('YYYY-MM-DD')
    }
    this.store.dispatch(
      loadAppliedLeaves({
        // params: null
        params: new URLSearchParams(params).toString(),
        page: this.currentPage,
        limit: this.pageLimit
      })
    )
  }

  onSearch() {
    this.currentPage = 1 // Reset to the first page on search
    const params = this.search ? `designationName=${encodeURIComponent(this.search)}` : null

    this.store.dispatch(
      loadAppliedLeaves({ params, page: this.currentPage, limit: this.pageLimit })
    ) // Dispatch action with filter
  }

  onPageChange(newPage: number): void {
    if (newPage > 0) {
      this.leaveId = null
      this.fromNotification = false
      this.currentPage = newPage
      this.loadAppliedLeaves() // Reload businesses for the new page
      this.updatePageLastRecord()
    }
  }

  private updatePageLastRecord() {
    this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
  }

  onPageLimitChange() {
    this.currentPage = 1 // Reset to first page when limit changes
    this.pageLastRecord = this.pageLimit
    this.loadAppliedLeaves() // Load employees with new page limit
  }

  openBusinessModal(content: TemplateRef<any>, options: any = {}) {
    this.store.dispatch(loadBusinesses({ params: 'disabled=false' }))
    // 1️⃣ Open modal first
    this.modalRef = this.modalService.open(content, {
      scrollable: false,
      centered: true,
      size: 'lg',
      // backdrop: 'static', // prevent outside click close
      // keyboard: false, // prevent ESC close
      ...options
    })

    // Handle both close and dismiss
    // 2️⃣ Handle close & dismiss events
    this.modalRef.result
      .then(() => {
        // Modal closed manually
        this.clearModalQueryParams()
      })
      .catch(() => {
        // Modal dismissed via outside click or ESC
        // this.status = 'Pending'
        // this.leaveId = null
        // this.fromNotification = false
        // this.dateRange = null
        // this.leaveType = ''
        // this.currentPage = 1
        // this.loadAppliedLeaves()
        this.resetModalData()
        this.clearModalQueryParams()
      })

    // this.modalRef = this.modalService.open(content, {
    //   scrollable: false,
    //   centered: true,
    //   size: 'lg',
    //   ...options
    // })
    // this.form.get('daterange')?.disable()
    if (!this.form.get('userId')?.value) {
      this.form.get('daterange')?.disable()
    } else {
      this.form.get('daterange')?.enable()
    }

    setTimeout(() => {
      this.initDatePicker()
    }, 0)

    //16oct2025 start
    // const minDate = dayjs(this.employeeJoiningDate).toDate() // ✅ Disables dates before joining

    // $('#dateRangeInputModal')
    //   .daterangepicker({
    //     autoUpdateInput: true, // ✅ Allow input field to update automatically
    //     minDate,
    //     locale: {
    //       format: 'DD/MM/YYYY', // Ensure format is correct
    //       cancelLabel: 'Clear'
    //     }
    //   })
    //   .on('apply.daterangepicker', (ev: any, picker: any) => {
    //     const formattedStart = picker.startDate.format('DD/MM/YYYY')
    //     const formattedEnd = picker.endDate.format('DD/MM/YYYY')

    //     // ✅ Update input field
    //     $('#dateRangeInputModal').val(`${formattedStart} - ${formattedEnd}`)
    //     this.form.get('fromDate')?.setValue(picker.startDate.format('YYYY-MM-DD'))
    //     this.form.get('toDate')?.setValue(picker.endDate.format('YYYY-MM-DD'))
    //     // this.form.get('fromDate')?.setValue(formattedStart)
    //     // this.form.get('toDate')?.setValue(formattedEnd)
    //     // console.log('from date', picker.startDate.format('YYYY-MM-DD'))
    //     this.isHalfDay = true
    //     this.generateDateRange()
    //     // ✅ Update Angular form
    //     // this.onDateChange(picker.startDate, picker.endDate);
    //   })
    //16 oct 2025 end

    // $('#dateRangeInputModals')
    //   .daterangepicker({
    //     autoUpdateInput: true, // ✅ Allow input field to update automatically
    //     locale: {
    //       format: 'DD/MM/YYYY', // Ensure format is correct
    //       cancelLabel: 'Clear'
    //     }
    //   })
    //   .on('apply.daterangepicker', (ev: any, picker: any) => {
    //     const formattedStart = picker.startDate.format('DD/MM/YYYY')
    //     const formattedEnd = picker.endDate.format('DD/MM/YYYY')
    //     // console.log('startDate', formattedStart)
    //     // console.log('enddate', formattedEnd)

    //     // ✅ Update input field
    //     $('#dateRangeInputModals').val(`${formattedStart} - ${formattedEnd}`)
    //     this.form.get('fromDate')?.setValue(picker.startDate)
    //     this.form.get('toDate')?.setValue(picker.endDate)
    //     // this.form.get('fromDate')?.setValue(formattedStart)
    //     // this.form.get('toDate')?.setValue(formattedEnd)
    //     this.isHalfDay = true
    //     this.generateDateRange()
    //     // ✅ Update Angular form
    //     // this.onDateChange(picker.startDate, picker.endDate);
    //   })
  }

  onClose() {
    // if (this.form) {
    //   this.form.reset(); // Reset the form if it is defined
    // }
    // this.modalService.dismissAll();
    // this.currentStep = 1;
    this.dateRangeforHalfDay = []
    this.parsedDateRange = []
    this.form.get('daterange')?.enable()
    this.EditHoliday = ''
    this.form.get('action')?.setValue(null)
    this.resetModalData()
    try {
      if (this.form) {
        this.form.reset()
      }
      if (this.modalRef) {
        this.modalRef.close()
      }
      this.modalService.dismissAll()
      this.router.navigate([], {
        queryParams: { openModal: null },
        queryParamsHandling: 'merge'
      })
    } catch (error) {
      console.error('Error closing modal:', error)
    }
  }
  getErrorMessage(controlName: string): string | null {
    const control = this.form.get(controlName)
    // console.log('control name', control)
    if (control && control.touched && control.invalid) {
      if (control.hasError('required')) {
        return 'This field is required'
      }
    }
    return null // No error
  }

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched()
      return
    }
    // this.form.get('dateRangeforHalfDay')?.setValue(JSON.stringify(this.dateRangeforHalfDay))
    const {
      daterange,
      offType,
      halfDayOption,
      businessId,
      leavePolicy,
      action,
      ...payloadWithoutDaterange
    } = this.form.value // ✅ Remove `daterange`
    // const fromDate = this.toUTCDateOnly(this.form.get('fromDate')?.value)
    // const toDate = this.toUTCDateOnly(this.form.get('toDate')?.value)
    const fromDate = this.form.get('fromDate')?.value
    const toDate = this.form.get('toDate')?.value

    const payload = {
      ...payloadWithoutDaterange,
      dateRangeforHalfDay: JSON.stringify(this.dateRangeforHalfDay), // manually assign
      fromDate,
      toDate
    }
    if (!this.EditHoliday) {
      this.store.dispatch(createAppliedLeave({ payload: payload }))
    } else {
      const payload = {
        ...payloadWithoutDaterange,
        ...(action !== undefined ? { action } : {})
      }

      this.store.dispatch(updateAppliedLeave({ id: this.EditHoliday.id, payload: payload }))
    }
    this.modalService.dismissAll() // Close modal
  }

  onHalfDayChange(index: number, option: string) {
    this.dateRangeforHalfDay[index].halfDayOption = option
  }

  // Function to Set Full Day or Half Day
  setDayType(index: number, type: 'FullDay' | 'HalfDay') {
    this.dateRangeforHalfDay[index].selectionType = type
    if (type === 'FullDay') {
      this.dateRangeforHalfDay[index].halfDayOption = '' // Reset half-day option
    }
  }

  generateDateRange() {
    const fromDate = new Date(this.form.get('fromDate')?.value)
    const toDate = new Date(this.form.get('toDate')?.value)

    if (fromDate && toDate && fromDate <= toDate) {
      // Ensure valid date range
      const tempDate = new Date(fromDate)

      this.dateRangeforHalfDay = [] // Reset before updating
      // tempDate.setDate(tempDate.getDate() + 1)
      tempDate.setDate(tempDate.getDate())

      const tempToDate = new Date(toDate)
      // tempToDate.setDate(tempToDate.getDate() + 1)
      tempToDate.setDate(tempToDate.getDate())

      while (tempDate <= tempToDate) {
        this.dateRangeforHalfDay.push({
          date: tempDate.toISOString().split('T')[0],
          selectionType: 'FullDay', // Default to FullDay
          halfDayOption: '' // Default value
        })
        tempDate.setDate(tempDate.getDate() + 1)
        // tempDate.setDate(tempDate.getDate())
      }
    }
  }

  openBlockUnblock(content: TemplateRef<any>, options: any = {}, status: any) {
    this.blockUnblockStatus = status
    this.EditHoliday = options
    this.form.get('fromDate')?.setValue(options.fromDate)
    this.form.get('toDate')?.setValue(options.toDate)
    this.form.get('reason')?.setValue(options.reason)
    this.form.get('leavePolicyId')?.setValue(options.leavePolicyId)
    this.form.get('userId')?.setValue(options.userId)
    // this.form.get('statusReason')?.setValue(options.status)

    this.form.get('statusReason')?.setValue(status)

    const controlName = 'dateRangeforHalfDay'

    // If control doesn't exist, create it
    if (!this.form.contains(controlName)) {
      this.form.addControl(controlName, this.fb.control([]))
    }

    // Now append to it
    const currentValue = this.form.get(controlName)?.value || []
    const newValue = [...currentValue, options.dateRangeforHalfDay]
    this.form.get(controlName)?.setValue(options.dateRangeforHalfDay)
    let action: string | null = null
    if (status === 'Approve') {
      if (options.status === 'Cancel Requested') {
        this.form.get('status')?.setValue('Cancelled')
      } else {
        this.form.get('status')?.setValue('Approved')
      }
    }
    if (status === 'Reject') {
      if (options.status === 'Cancel Requested') {
        this.form.get('status')?.setValue('Approved')
        action = 'RejectCancelRequest'
      } else {
        this.form.get('status')?.setValue('Rejected')
      }
    }
    if (status === 'Cancel') {
      if (options.status === 'Approved') {
        // this.form.get('status')?.setValue('Approved')
        this.form.get('status')?.setValue('Cancelled')
      } else if (options.status === 'Cancel Requested') {
        this.form.get('status')?.setValue('Approved')
        action = 'CancelCancelRequest'
      } else {
        this.form.get('status')?.setValue('Cancelled')
      }
    }

    if (!this.form.contains('action')) {
      this.form.addControl('action', this.fb.control(''))
    }
    this.form.get('action')?.setValue(action)

    this.modalService.open(content, { scrollable: false, centered: true, size: 'sm' })
  }

  openleavereqDetailModal(content: any, leave: any) {
    this.employeeLeaveDetail = leave
    this.dateRangeforHalfDay = JSON.parse(leave.dateRangeforHalfDay)
    this.modalService.open(content, { scrollable: false, centered: true, size: 'md' })
  }

  onBusinessChange(businessId: string) {
    this.store.dispatch(resetEmployeeState())
    this.form.get('userId')?.setValue('')
    if (businessId) {
      // Call a method to fetch data based on the selected owner
      const params = `businessId=${encodeURIComponent(businessId)}&disabled=false`

      this.store.dispatch(loadEmployees({ params })) // Dispatch action with filter
    } else {
      const params = 'disabled=false'
      this.store.dispatch(loadEmployees({ params })) // Dispatch action with filter
      // Dispatch action with filter
      // Handle the case where no owner is selected
      // console.log('No business selected')
    }
  }

  getDashboardRoute(): string {
    // return this.user?.role.name === 'Admin' ? eps.dashboardPath : eps.employeeDashboardPath
    return this.utilsService.getDashboardRoute()
  }

  customSearchFnBusiness = (term: string, item: any) => {
    const fullName = `${item.businessName}`.toLowerCase()
    return fullName.includes(term.toLowerCase())
  }

  customSearchFnEmployee = (term: string, item: any) => {
    const fullName = `${item.firstName} ${item.lastName}`.toLowerCase()
    return fullName.includes(term.toLowerCase())
  }

  onEmployeeSelect() {
    this.form.get('leavePolicyId')?.setValue(null)
    this.form.get('leavePolicy')?.setValue(null)

    const employeeId = this.form.get('userId')?.value
    this.leavePolicies$ = this.leavePolicyService.assignedPolicyByUserId(employeeId)
    // Subscribe to employees$ to get the latest list (if not already available as an array)
    if (employeeId) {
      this.employees$
        .subscribe(employees => {
          const selectedEmployee = employees.find(emp => emp.id === employeeId)
          if (selectedEmployee) {
            // If joiningDate can be Date or string, coerce to string:
            this.employeeJoiningDate =
              typeof selectedEmployee.joiningDate === 'string'
                ? selectedEmployee.joiningDate
                : selectedEmployee.joiningDate.toISOString() // Or .toLocaleDateString(), etc.
          }
          this.form.get('daterange')?.enable()
          setTimeout(() => {
            this.initDatePicker()
          })
        })
        .unsubscribe() // Unsubscribe immediately to avoid memory leak
      const minDate = dayjs(this.employeeJoiningDate).toDate() // ✅ Disables dates before joining

      $('#dateRangeInputModal')
        .daterangepicker({
          autoUpdateInput: true, // ✅ Allow input field to update automatically
          minDate,
          locale: {
            format: 'DD/MM/YYYY', // Ensure format is correct
            cancelLabel: 'Clear'
          }
        })
        .on('apply.daterangepicker', (ev: any, picker: any) => {
          const formattedStart = picker.startDate.format('DD/MM/YYYY')
          const formattedEnd = picker.endDate.format('DD/MM/YYYY')

          // ✅ Update input field
          $('#dateRangeInput').val(`${formattedStart} - ${formattedEnd}`)
          this.form.get('fromDate')?.setValue(picker.startDate.format('YYYY-MM-DD'))
          this.form.get('toDate')?.setValue(picker.endDate.format('YYYY-MM-DD'))
          // this.form.get('fromDate')?.setValue(formattedStart)
          // this.form.get('toDate')?.setValue(formattedEnd)
          // console.log('from date', picker.startDate.format('YYYY-MM-DD'))
          this.isHalfDay = true
          this.generateDateRange()
          // ✅ Update Angular form
          // this.onDateChange(picker.startDate, picker.endDate);
        })
    }
  }

  initDatePicker() {
    // const existing = $('#dateRangeInput').data('daterangepicker')
    const existing = $('#dateRangeInputModal').data('daterangepicker')
    // const existing = $('#dateRangeInputModal').data('daterangepicker')
    if (existing) {
      existing.remove()
    }
    const minDate = this.employeeJoiningDate ? dayjs(this.employeeJoiningDate).toDate() : null
    // $('#dateRangeInput')
    $('#dateRangeInputModal')
      .daterangepicker({
        autoUpdateInput: true,
        minDate,
        locale: {
          format: 'DD/MM/YYYY',
          cancelLabel: 'Clear'
        }
      })
      .on('apply.daterangepicker', (ev: any, picker: any) => {
        const start = picker.startDate
        const end = picker.endDate

        const formattedStart = start.format('DD/MM/YYYY')
        const formattedEnd = end.format('DD/MM/YYYY')
        // $('#dateRangeInput').val(`${formattedStart} - ${formattedEnd}`)
        $('#dateRangeInputModal')
          .val(`${formattedStart} - ${formattedEnd}`)
          // this.dateRange = {
          //   startDate: start,
          //   endDate: end
          // }
          .on('apply.daterangepicker', (ev: any, picker: any) => {
            const start = picker.startDate
            const end = picker.endDate

            const formattedStart = start.format('DD/MM/YYYY')
            const formattedEnd = end.format('DD/MM/YYYY')

            $('#dateRangeInputModal').val(`${formattedStart} - ${formattedEnd}`)
            this.form.get('fromDate')?.setValue(start.format('YYYY-MM-DD'))
            this.form.get('toDate')?.setValue(end.format('YYYY-MM-DD'))
            this.form.get('daterange')?.setValue(`${formattedStart} - ${formattedEnd}`)

            this.isHalfDay = true
            this.generateDateRange()
          })
        this.loadAppliedLeaves()
        this.form.get('fromDate')?.setValue(start.format('YYYY-MM-DD'))
        this.form.get('toDate')?.setValue(end.format('YYYY-MM-DD'))
        this.isHalfDay = true
        this.generateDateRange()
      })
  }

  openOffcanvasLeave(leave: any) {
    this.selectedLeave = leave
    if (this.selectedLeave?.dateRangeforHalfDay) {
      try {
        this.parsedDateRange = JSON.parse(this.selectedLeave.dateRangeforHalfDay)
      } catch (error) {
        console.error('Invalid JSON in dateRangeforHalfDay:', error)
        this.parsedDateRange = []
      }
    }
  }

  // onImageError(employee: any): void {
  //   employee.picture = null // fallback triggers initials
  // }

  getInitials(firstName: string = '', lastName: string = ''): string {
    const firstInitial = firstName?.charAt(0) || ''
    const lastInitial = lastName?.charAt(0) || ''
    return (firstInitial + lastInitial).toUpperCase()
  }

  toUTCDateOnly(dateInput: string | Date): Date {
    const date = new Date(dateInput)
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
  }

  onStatusChange() {
    this.leaveId = null
    this.fromNotification = false
    this.currentPage = 1 // Reset to first page when limit changes
    this.loadAppliedLeaves() // Load employees with new page limit
  }

  clearModalQueryParams() {
    this.router.navigate([], {
      queryParams: { openModal: null },
      queryParamsHandling: 'merge',
      replaceUrl: true
    })
  }

  private resetModalData() {
    this.form.reset({
      status: 'Pending',
      statusReason: '',
      businessId: '',
      userId: '',
      leavePolicyId: '',
      leavePolicy: ''
    })

    this.selectedBusinessId = ''
    this.EditHoliday = ''
    this.dateRangeforHalfDay = []
    this.parsedDateRange = []
    this.employeeJoiningDate = ''
    this.leavePolicies$ = of([])
    this.form.get('daterange')?.disable()
  }

  isBusinessOwner(): boolean {
    return this.utilsService.isBusinessOwner()
  }
}
